import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button from '../Button';
import containerQueryProps from '../../props/containerQueryProps';
import ResyLogo from '../../svg/icons/logo.svg';
import OPENAI_WIDGET from '../../../../widget/app/modules/constants/srcTypes';

import './ModalNav.scss';
import { getTranslation } from '../../providers/TranslationProvider';

const ModalNav = (props) => {
  const {
    onBackClick, close, showBack, containerQuery, sourceId,
  } = props;

  const { sm } = containerQuery;

  const onClose = () => {
    close();
    // analytics?
  };

  const renderClose = () => {
    if (sourceId === OPENAI_WIDGET) return null;

    return (
      <Button
        aria-label={getTranslation({
          translationKey: 'close',
          fallback: 'close',
        })}
        variant="close"
        onClick={onClose}
      />
    );
  };

  const renderLogo = () => {
    if (sourceId === OPENAI_WIDGET) return null;

    return (
      <div
        className={cx('ModalNav__Logo', {
          'ModalNav__Logo--sm': sm,
        })}
      >
        <ResyLogo
          height="28px"
          width="65px"
          aria-label={getTranslation({
            translationKey: 'resy_logo',
            fallback: 'resy logo',
          })}
          role="img"
        />
      </div>
    );
  };

  return (
    <div
      className={cx('ModalNav', {
        'ModalNav--sm': sm,
        'ModalNav--gpt': sourceId === OPENAI_WIDGET,
      })}
    >
      {showBack && (
        <Button
          onClick={onBackClick}
          variant="back"
          aria-label={getTranslation({
            translationKey: 'back',
            fallback: 'back',
          })}
        />
      )}

      {renderClose()}
      {renderLogo()}
    </div>
  );
};

ModalNav.propTypes = {
  close: PropTypes.func.isRequired,
  containerQuery: containerQueryProps,
  onBackClick: PropTypes.func,
  showBack: PropTypes.bool,
  sourceId: PropTypes.string,
};

ModalNav.defaultProps = {
  containerQuery: {},
  onBackClick: undefined,
  showBack: true,
  sourceId: undefined,
};

ModalNav.displayName = 'ModalNav';

export default ModalNav;
